import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabase';

// ── Yardımcı ────────────────────────────────────────────────
const durumRenk = (durum) => {
  switch (durum) {
    case 'Teslim Edildi': return { bg: '#EAF3DE', renk: '#3B6D11' };
    case 'Gümrükte':      return { bg: '#FEF3C7', renk: '#854F0B' };
    case 'Yolda':         return { bg: '#DBEAFE', renk: '#1D4ED8' };
    case 'Dağıtımda':     return { bg: '#F3E8FF', renk: '#6B21A8' };
    case 'Yüklendi':      return { bg: '#E0F2FE', renk: '#0369A1' };
    default:              return { bg: '#F3F4F6', renk: '#6B7280' };
  }
};

const tarihFormat = (tarih) => {
  if (!tarih) return '—';
  return new Date(tarih).toLocaleDateString('tr-TR', { day: '2-digit', month: 'long', year: 'numeric' });
};

// ── Header bileşeni ──────────────────────────────────────────
function Header({ kullanici, onCikis, onGeri, baslik }) {
  return (
    <div style={{
      background: '#0D3B7A', color: '#fff',
      padding: '0 16px', height: '56px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      position: 'sticky', top: 0, zIndex: 100,
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      {/* Sol: logo veya geri butonu */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {onGeri ? (
          <button onClick={onGeri}
            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontSize: '14px' }}>
            ← Geri
          </button>
        ) : (
          <div>
            <img src="/logo.png" alt="BYR SWORD" style={{ height: '36px', objectFit: 'contain', borderRadius: '4px' }} />
          </div>
        )}
        {baslik && (
          <div style={{ fontSize: '15px', fontWeight: '600', marginLeft: onGeri ? 0 : '12px', borderLeft: onGeri ? 'none' : '1px solid rgba(255,255,255,0.2)', paddingLeft: onGeri ? 0 : '12px' }}>
            {baslik}
          </div>
        )}
      </div>

      {/* Sağ: kullanıcı adı + çıkış */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '13px', fontWeight: '600' }}>{kullanici?.ad || 'Sürücü'}</div>
          <div style={{ fontSize: '10px', color: '#93C5FD' }}>Sürücü</div>
        </div>
        <button onClick={onCikis}
          style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', color: '#fff', borderRadius: '8px', padding: '6px 12px', cursor: 'pointer', fontSize: '12px', fontWeight: '500' }}>
          Çıkış
        </button>
      </div>
    </div>
  );
}

// ── Ana bileşen ──────────────────────────────────────────────
function SurucuPanel({ onCikis }) {
  const [seferler, setSeferler]         = useState([]);
  const [yukleniyor, setYukleniyor]     = useState(true);
  const [secilenSefer, setSecilenSefer] = useState(null);

  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');

  const seferleriGetir = useCallback(async () => {
    setYukleniyor(true);

    // Önce surucu_id ile dene
    if (kullanici.id) {
      const { data: idData } = await supabase
        .from('seferler')
        .select('*')
        .eq('surucu_id', kullanici.id)
        .order('created_at', { ascending: false });

      if (idData && idData.length > 0) {
        setSeferler(idData);
        setYukleniyor(false);
        return;
      }
    }

    // Fallback: surucu_ad ile eşleştir
    const { data } = await supabase
      .from('seferler')
      .select('*')
      .eq('surucu_ad', kullanici.ad)
      .order('created_at', { ascending: false });

    if (data) setSeferler(data);
    setYukleniyor(false);
  }, [kullanici.id, kullanici.ad]);

  useEffect(() => { seferleriGetir(); }, [seferleriGetir]);

  if (secilenSefer) {
    return (
      <SeferDetayi
        sefer={secilenSefer}
        kullanici={kullanici}
        onGeri={() => setSecilenSefer(null)}
        onCikis={onCikis}
      />
    );
  }

  const aktifSeferler  = seferler.filter(s => s.durum !== 'Teslim Edildi');
  const gecmisSeferler = seferler.filter(s => s.durum === 'Teslim Edildi');

  return (
    <div style={{ minHeight: '100vh', background: '#F1F5F9', fontFamily: 'Arial, sans-serif' }}>
      <Header kullanici={kullanici} onCikis={onCikis} />

      <div style={{ maxWidth: '640px', margin: '0 auto', padding: '20px 16px' }}>

        {/* Özet şerit */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '24px' }}>
          {[
            { label: 'Toplam',    value: seferler.length,        renk: '#1a1a1a' },
            { label: 'Aktif',     value: aktifSeferler.length,   renk: '#1D4ED8' },
            { label: 'Tamamlandı', value: gecmisSeferler.length, renk: '#3B6D11' },
          ].map((k, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: '12px', padding: '14px 12px', textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.07)' }}>
              <div style={{ fontSize: '24px', fontWeight: '800', color: k.renk }}>{yukleniyor ? '·' : k.value}</div>
              <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{k.label}</div>
            </div>
          ))}
        </div>

        {/* Aktif seferler */}
        <SectionTitle title="Aktif Seferler" count={aktifSeferler.length} />

        {yukleniyor ? (
          <YuklenivorKart />
        ) : aktifSeferler.length === 0 ? (
          <BosKart mesaj="Aktif seferiniz bulunmuyor" ikon="🚛" />
        ) : (
          aktifSeferler.map(s => (
            <SeferKarti key={s.id} sefer={s} onClick={() => setSecilenSefer(s)} />
          ))
        )}

        {/* Geçmiş seferler */}
        {gecmisSeferler.length > 0 && (
          <>
            <SectionTitle title="Tamamlanan Seferler" count={gecmisSeferler.length} style={{ marginTop: '28px' }} />
            {gecmisSeferler.map(s => (
              <SeferKarti key={s.id} sefer={s} onClick={() => setSecilenSefer(s)} gecmis />
            ))}
          </>
        )}
      </div>
    </div>
  );
}

// ── Sefer Kartı ──────────────────────────────────────────────
function SeferKarti({ sefer, onClick, gecmis }) {
  const { bg, renk } = durumRenk(sefer.durum);
  return (
    <div
      onClick={onClick}
      style={{
        background: '#fff',
        borderRadius: '14px',
        padding: '18px 18px 14px',
        marginBottom: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
        cursor: 'pointer',
        opacity: gecmis ? 0.75 : 1,
        border: '1px solid #E2E8F0',
        transition: 'box-shadow 0.15s',
      }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.12)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.08)'}
    >
      {/* Üst satır: sefer no + durum */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <div style={{ fontSize: '17px', fontWeight: '800', color: '#0D3B7A', letterSpacing: '0.3px' }}>
          {sefer.sefer_no}
        </div>
        <span style={{ background: bg, color: renk, padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '700' }}>
          {sefer.durum}
        </span>
      </div>

      {/* Bilgi satırları */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', marginBottom: '14px' }}>
        <InfoSatir label="Güzergah" value={sefer.guzergah} />
        <InfoSatir label="Tahmini Varış" value={tarihFormat(sefer.tahmini_varis)} />
        {sefer.plaka && <InfoSatir label="Plaka" value={sefer.plaka} />}
      </div>

      {/* Detay butonu */}
      <button
        style={{
          width: '100%', padding: '11px', background: '#0D3B7A', color: '#fff',
          border: 'none', borderRadius: '10px', fontSize: '14px',
          fontWeight: '700', cursor: 'pointer', letterSpacing: '0.3px',
        }}>
        Detay Gör →
      </button>
    </div>
  );
}

// ── Sefer Detay ──────────────────────────────────────────────
function SeferDetayi({ sefer, kullanici, onGeri, onCikis }) {
  const [mallar, setMallar]             = useState([]);
  const [yukleniyor, setYukleniyor]     = useState(true);
  const [mevcutDurum, setMevcutDurum]   = useState(sefer.durum);
  const [durumModal, setDurumModal]     = useState(false);
  const [secilenDurum, setSecilenDurum] = useState(sefer.durum);
  const [kaydediyor, setKaydediyor]     = useState(false);

  const mallariGetir = useCallback(async () => {
    setYukleniyor(true);
    const { data } = await supabase
      .from('depo')
      .select('*, musteriler(ad, sehir)')
      .eq('sefer_id', sefer.id);
    if (data) setMallar(data);
    setYukleniyor(false);
  }, [sefer.id]);

  useEffect(() => { mallariGetir(); }, [mallariGetir]);

  const durumGuncelle = async () => {
    if (secilenDurum === mevcutDurum) { setDurumModal(false); return; }
    setKaydediyor(true);
    const { error } = await supabase
      .from('seferler')
      .update({ durum: secilenDurum })
      .eq('id', sefer.id);
    if (error) {
      alert('Hata: ' + error.message);
      setKaydediyor(false);
      return;
    }
    // Teslim Edildi ise tüm malları da güncelle
    if (secilenDurum === 'Teslim Edildi') {
      await supabase.from('depo').update({ durum: 'Teslim Edildi' }).eq('sefer_id', sefer.id);
    }
    setMevcutDurum(secilenDurum);
    sefer.durum = secilenDurum; // lokal güncelle
    setDurumModal(false);
    setKaydediyor(false);
    mallariGetir();
  };

  const { bg, renk } = durumRenk(mevcutDurum);

  const DURUM_ADIMLAR = [
    { durum: 'Yükleme Bekliyor', ikon: '📦', aciklama: 'Mal depoda, yükleme bekleniyor' },
    { durum: 'Yüklendi',         ikon: '🚛', aciklama: 'Mallar araca yüklendi' },
    { durum: 'Yolda',            ikon: '🛣️',  aciklama: 'Araç yolda' },
    { durum: 'Gümrükte',         ikon: '🛂', aciklama: 'Gümrük işlemleri devam ediyor' },
    { durum: 'Dağıtımda',        ikon: '📬', aciklama: 'Teslimat bölgesinde dağıtım yapılıyor' },
    { durum: 'Teslim Edildi',    ikon: '✅', aciklama: 'Tüm mallar teslim edildi' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#F1F5F9', fontFamily: 'Arial, sans-serif' }}>
      <Header kullanici={kullanici} onCikis={onCikis} onGeri={onGeri} baslik={sefer.sefer_no} />

      <div style={{ maxWidth: '640px', margin: '0 auto', padding: '20px 16px' }}>

        {/* Durum badge + Güncelle butonu */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', background: '#fff', borderRadius: '14px', padding: '16px 18px', border: '1px solid #E2E8F0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div>
            <div style={{ fontSize: '11px', color: '#9CA3AF', marginBottom: '4px' }}>Mevcut Durum</div>
            <span style={{ background: bg, color: renk, padding: '6px 16px', borderRadius: '20px', fontSize: '13px', fontWeight: '800' }}>
              {mevcutDurum}
            </span>
          </div>
          {mevcutDurum !== 'Teslim Edildi' && (
            <button
              onClick={() => { setSecilenDurum(mevcutDurum); setDurumModal(true); }}
              style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: '10px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>
              🔄 Durum Güncelle
            </button>
          )}
        </div>

        {/* Sefer Bilgileri */}
        <BilgiKarti baslik="📋 Sefer Bilgileri" satirlar={[
          ['Sefer No',       sefer.sefer_no],
          ['Güzergah',       sefer.guzergah],
          ['Plaka',          sefer.plaka],
          ['Tahmini Varış',  tarihFormat(sefer.tahmini_varis)],
          ['Toplam Yük',     yukleniyor
            ? 'Yükleniyor...'
            : mallar.length === 0
              ? '—'
              : `${mallar.length} kalem / ${mallar.reduce((t, m) => t + (parseFloat(m.agirlik) || 0), 0).toLocaleString('tr-TR')} kg`
          ],
        ]} />

      {/* Durum Güncelle Modal */}
      {durumModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 200 }}>
          <div style={{ background: '#fff', borderRadius: '20px 20px 0 0', padding: '24px 20px 36px', width: '100%', maxWidth: '640px', boxShadow: '0 -4px 24px rgba(0,0,0,0.15)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: '#0D3B7A' }}>Durum Güncelle</div>
              <button onClick={() => setDurumModal(false)} style={{ background: '#F1F5F9', border: 'none', borderRadius: '50%', width: '32px', height: '32px', fontSize: '16px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
              {DURUM_ADIMLAR.map(({ durum, ikon, aciklama }) => (
                <div
                  key={durum}
                  onClick={() => setSecilenDurum(durum)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '14px',
                    padding: '14px 16px', borderRadius: '12px', cursor: 'pointer',
                    border: `2px solid ${secilenDurum === durum ? '#0D3B7A' : '#E2E8F0'}`,
                    background: secilenDurum === durum ? '#EFF6FF' : '#fff',
                    transition: 'all 0.15s',
                  }}>
                  <span style={{ fontSize: '22px' }}>{ikon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: secilenDurum === durum ? '700' : '500', color: secilenDurum === durum ? '#0D3B7A' : '#374151' }}>
                      {durum}
                    </div>
                    <div style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>{aciklama}</div>
                  </div>
                  {secilenDurum === durum && (
                    <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#0D3B7A', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '12px', flexShrink: 0 }}>✓</div>
                  )}
                </div>
              ))}
            </div>
            <button
              onClick={durumGuncelle}
              disabled={kaydediyor || secilenDurum === mevcutDurum}
              style={{
                width: '100%', padding: '16px', background: '#0D3B7A', color: '#fff',
                border: 'none', borderRadius: '12px', fontSize: '15px', fontWeight: '700',
                cursor: secilenDurum === mevcutDurum ? 'not-allowed' : 'pointer',
                opacity: secilenDurum === mevcutDurum ? 0.5 : 1,
              }}>
              {kaydediyor ? 'Kaydediliyor...' : 'Güncelle'}
            </button>
          </div>
        </div>
      )}

        {/* Yüklenen Mallar */}
        <div style={{ background: '#fff', borderRadius: '14px', border: '1px solid #E2E8F0', overflow: 'hidden', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
          <div style={{ padding: '14px 18px', borderBottom: '1px solid #F1F5F9', background: '#F8FAFC' }}>
            <div style={{ fontSize: '14px', fontWeight: '700', color: '#0D3B7A' }}>
              📦 Yüklenen Mallar
              <span style={{ marginLeft: '8px', background: '#E0E7FF', color: '#3730A3', padding: '2px 8px', borderRadius: '10px', fontSize: '12px' }}>
                {yukleniyor ? '...' : mallar.length + ' kalem'}
              </span>
            </div>
          </div>

          {yukleniyor ? (
            <YuklenivorKart />
          ) : mallar.length === 0 ? (
            <BosKart mesaj="Bu sefere henüz mal eklenmemiş" ikon="📦" />
          ) : (
            <div>
              {mallar.map((m, i) => (
                <div key={m.id} style={{ padding: '14px 18px', borderTop: i === 0 ? 'none' : '1px solid #F1F5F9' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '6px' }}>
                    <div style={{ fontWeight: '600', fontSize: '14px', color: '#1a1a1a' }}>
                      {m.urun_adi || m.urun || '—'}
                    </div>
                    <span style={{
                      background: m.durum === 'Teslim Edildi' ? '#EAF3DE' : '#F3F4F6',
                      color: m.durum === 'Teslim Edildi' ? '#3B6D11' : '#6B7280',
                      padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '600'
                    }}>
                      {m.durum}
                    </span>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
                    <InfoSatir label="Şehir"    value={m.musteriler?.sehir || '—'} kucuk />
                    <InfoSatir label="Koli"     value={m.koli_sayisi || m.miktar ? `${m.koli_sayisi || m.miktar} koli` : '—'} kucuk />
                    <InfoSatir label="Ağırlık"  value={m.agirlik ? `${m.agirlik} kg` : '—'} kucuk />
                    {(m.hedef || m.hedef_ulke) && <InfoSatir label="Hedef" value={m.hedef || m.hedef_ulke} kucuk />}
                    {m.barkod_no && <InfoSatir label="Barkod" value={m.barkod_no} kucuk mono />}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

// ── Küçük yardımcı bileşenler ────────────────────────────────
function SectionTitle({ title, count, style }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', ...style }}>
      <div style={{ fontSize: '14px', fontWeight: '700', color: '#374151' }}>{title}</div>
      <div style={{ background: '#E0E7FF', color: '#3730A3', padding: '1px 8px', borderRadius: '10px', fontSize: '12px', fontWeight: '600' }}>
        {count}
      </div>
    </div>
  );
}

function BilgiKarti({ baslik, satirlar }) {
  return (
    <div style={{ background: '#fff', borderRadius: '14px', border: '1px solid #E2E8F0', overflow: 'hidden', marginBottom: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      <div style={{ padding: '14px 18px', borderBottom: '1px solid #F1F5F9', background: '#F8FAFC' }}>
        <div style={{ fontSize: '14px', fontWeight: '700', color: '#0D3B7A' }}>{baslik}</div>
      </div>
      <div style={{ padding: '4px 0' }}>
        {satirlar.map(([label, val]) => val ? (
          <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 18px', borderBottom: '1px solid #F8FAFC' }}>
            <span style={{ fontSize: '13px', color: '#6B7280' }}>{label}</span>
            <span style={{ fontSize: '13px', fontWeight: '600', color: '#1a1a1a' }}>{val}</span>
          </div>
        ) : null)}
      </div>
    </div>
  );
}

function InfoSatir({ label, value, kucuk, mono }) {
  return (
    <div>
      <div style={{ fontSize: '10px', color: '#9CA3AF', marginBottom: '1px' }}>{label}</div>
      <div style={{ fontSize: kucuk ? '12px' : '13px', fontWeight: '500', color: '#374151', fontFamily: mono ? 'monospace' : 'inherit' }}>
        {value || '—'}
      </div>
    </div>
  );
}

function YuklenivorKart() {
  return (
    <div style={{ padding: '32px', textAlign: 'center', color: '#9CA3AF', fontSize: '14px' }}>
      Yükleniyor...
    </div>
  );
}

function BosKart({ mesaj, ikon }) {
  return (
    <div style={{ background: '#fff', borderRadius: '14px', border: '1px dashed #CBD5E1', padding: '48px 24px', textAlign: 'center', marginBottom: '12px' }}>
      <div style={{ fontSize: '40px', marginBottom: '12px' }}>{ikon}</div>
      <div style={{ fontSize: '16px', fontWeight: '600', color: '#64748B' }}>{mesaj}</div>
    </div>
  );
}

export default SurucuPanel;
